import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { ActionRegistryItem } from '../../../registry/action/ActionRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class DeferActionsRuntime extends ActionRegistryCategory {
    label = 'Runtime';
    constructor(parent) {
        super(parent);
        super.init();
    }
    requestFullscreen = () => new ActionRegistryItem({
        action: () => runtime.solidBrowserRuntime.browserFullscreen.requestFullScreen()
    });
}
